export const driveInOut = "driveInOut";
export const walkInOut = "walkInOut";
export const trainInOut = "trainInOut";
